module.exports = __webpack_public_path__ + "img/ville-drummondville.282c1123.webp";